$(document).ready(function() {
  var inputElement = $(".main-search__input");
  var iconElement = $(".show-search-link__icon, .main-search__button, .mobile-search .boost-pfs-search-btn-clear-suggestion");
  inputElement.css({
    "opacity": 0,
    "visibility": "hidden"
  });
    iconElement.css({
    "opacity": 0,
    "visibility": "hidden"
  });
  setTimeout(function() {
    inputElement.attr("placeholder", "Search for products");
    inputElement.css({
      "opacity": 1, "visibility": "visible" });
    iconElement.css({
      "opacity": 1, "visibility": "visible"  });
  }, 1000);

if ($(window).width() <= 1300) {
    $(".logo-area__right__inner .page-header").click(function() {
        $(".mobile-search").toggle();
    });
}

var inputElementmbl = $(".main-search__input");
  var clearButtonmbl = $(".mobile-search .boost-pfs-search-btn-clear-suggestion");
  clearButtonmbl.click(function() {
    inputElementmbl.val("");
  });

var inputElementdesk = $(".main-search__input");
  var clearButtondesk = $(".desktop-search .boost-pfs-search-btn-clear-suggestion");
  clearButtondesk.click(function() {
    inputElementdesk.val("");
  });

function checkCountdown() {
      var days = parseInt($(".js-daysx").text());
      var hours = parseInt($(".js-hoursx").text());
      var minutes = parseInt($(".js-minutesx").text());
      var seconds = parseInt($(".js-secondsx").text());

      if (days > 0 || hours > 0 || minutes > 0 || seconds > 0) {
        $(".announcement").css("display", "none");
      } else {
        $(".announcement").css("display", "block");
      }
    }
    checkCountdown();
    setInterval(checkCountdown, 1000); 


// Page Load Timer
function checkCountdownload() { 
      var days1 = $(".js-daysx").text().trim();
      var hours1 = $(".js-hoursx").text().trim();
      var minutes1 = $(".js-minutesx").text().trim();
      var seconds1 = $(".js-secondsx").text().trim();

      if (days1 === "00" && hours1 === "00" && minutes1 === "00" && seconds1 === "00") {
        $(".countdown_timex").css("display", "none");
      } else {
        $(".countdown_timex").css("display", "flex");
      }
    }
    checkCountdownload();
    setInterval(checkCountdownload, 100);

// on pageload Timerload
 function checkCountdowntimer() {
      var days2 = parseInt($(".js-daysx").text());
      var hours2 = parseInt($(".js-hoursx").text());
      var minutes2 = parseInt($(".js-minutesx").text());
      var seconds2 = parseInt($(".js-secondsx").text());

      var countdownTimex = $(".countdown_timex");

      if (days2 > 0 || hours2 > 0 || minutes2 > 0 || seconds2 > 0) {
        countdownTimex.css("opacity", 1);
      } else {
        countdownTimex.css("opacity", 0);
      }
    }
    checkCountdowntimer();
    setInterval(checkCountdowntimer, 100); 

// 

function checkCountdown() {
      var days3 = parseInt($(".js-daysx").text());
      var hours3 = parseInt($(".js-hoursx").text());
      var minutes3 = parseInt($(".js-minutesx").text());
      var seconds3 = parseInt($(".js-secondsx").text());

      if (days3 > 0 || hours3 > 0 || minutes3 > 0 || seconds3 > 0) {
        $(".announcement").css("opacity", "0");
        $(".announcement").css("display", "none");
      } else {
        $(".announcement").css("opacity", "1");
         $(".announcement").css("display", "block");
      }
    }
    checkCountdown();
    setInterval(checkCountdown, 1000); 
  
})